import { render, staticRenderFns } from "./LottoRateTransfer.vue?vue&type=template&id=7a940392&"
import script from "./LottoRateTransfer.vue?vue&type=script&lang=js&"
export * from "./LottoRateTransfer.vue?vue&type=script&lang=js&"
import style0 from "./LottoRateTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports